// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + ({"178":"page-blog-detail","628":"page-home","938":"page-blog"}[chunkId] || chunkId) + "." + {"120":"6e7107f8","178":"d86e881c","628":"2d31cb7f","856":"3de859a8","861":"db5043ba","938":"b62bb7d1"}[chunkId] + ".js";
};